import React, { useEffect, useState } from 'react';
import { FlexSpace } from './shared/FlexSpace';
import Timer from './Timer';
import styled from 'styled-components';
import media from '../style/media';

const InfoContent = styled(FlexSpace)`
  padding: 5px 5px;
  width: 100%;
  height: 25px;
  box-sizing: border-box;
  ${media.tablet`
    padding: 5px 1px;
  `}
`;

const LicenseInfo = styled.div`
  font-size: 16px;
  color: #01061b;
`;

interface IInfoBar {
    /**
     *  Displays whether the current session state is measuring
     */
    isMeasuring: boolean;
    /**
     *  Total number of seconds for current measurement
     */
    durationSeconds: number;
    /**
     *  Show timer if true
     */
    showTimer: boolean;
    /**
     * Object - offline measurement info for license by measurement
     */
    offlineMeasurements: {
        measurementSecondsEnd: number;
        offlineMeasurements: number;
        offlineMeasurementsRemaining: number;
    };
    infoMessage: string;
}

const InfoBar = ({
    isMeasuring,
    durationSeconds,
    showTimer,
    offlineMeasurements,
    infoMessage,
}: IInfoBar) => {
    const [timerId, setTimerId] = useState(null);
    const [measurementSecondsEnd, setMeasurementSecondsEnd] = useState<number>(0);
    const measurementSecondsEndToDisplay = measurementSecondsEnd
        ? ' | ' + new Date(measurementSecondsEnd * 1000).toISOString().substr(14, 5)
        : ' | 00:00';

    useEffect(() => {
        setMeasurementSecondsEnd(offlineMeasurements?.measurementSecondsEnd);
    }, [offlineMeasurements?.measurementSecondsEnd]);

    useEffect(() => {
        if (timerId === null && measurementSecondsEnd > 0) {
            const id = setInterval(() => {
                setMeasurementSecondsEnd((prev) => {
                    if (prev === 0) {
                        clearInterval(id);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            setTimerId(id);

            // Cleanup function
            return () => {
                clearInterval(id);
            };
        }
    }, [measurementSecondsEnd]);

    // Also add cleanup for when component unmounts
    useEffect(() => {
        return () => {
            if (timerId) {
                clearInterval(timerId);
            }
        };
    }, [timerId]);


    return (
        <InfoContent>
            {showTimer && (
                <Timer started={isMeasuring} durationSeconds={durationSeconds} infoMessage={infoMessage} />
            )}
        </InfoContent>
    );
};
export default InfoBar;
